export default __webpack_public_path__ + "static/media/Flag_of_Senegal.d63877de.svg";